module.exports = __webpack_public_path__ + "media/images/map_tokyo_direction2-607736ad0a9d09c61200b86e8bf89c23.jpg";